import React from 'react';
import { PrinterIcon, PaintBrushIcon, ShoppingBagIcon } from '@heroicons/react/24/outline';

const audiences = [
  {
    icon: PrinterIcon,
    title: 'DTF & UVDTF Printers',
    description: 'Fill your printer with profitable orders and zero-waste gang sheets.',
    gradient: 'from-mint-500 to-mint-600',
    bg: 'bg-mint-50',
  },
  {
    icon: PaintBrushIcon,
    title: 'Designers & Artists',
    description: 'Turn artwork into listed products across Etsy, Shopify, and your own storefront.',
    gradient: 'from-lavender-500 to-lavender-600',
    bg: 'bg-lavender-50',
  },
  {
    icon: ShoppingBagIcon,
    title: 'Print-on-Demand Sellers',
    description: 'One dashboard for listings, orders, mockups, print files, and shipping.',
    gradient: 'from-peach-500 to-peach-600',
    bg: 'bg-peach-50',
  },
];

const AudienceSection = () => {
  return (
    <section className="py-16 md:py-24 bg-gray-50/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">Built for print businesses</h2>
          <p className="text-lg text-gray-500 max-w-xl mx-auto">
            Whether you're printing, designing, or selling — CraftFlow automates the busywork.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {audiences.map(item => (
            <div key={item.title} className="relative group">
              <div className="bg-white rounded-2xl p-8 border border-gray-100 hover:border-gray-200 hover:shadow-lg transition-all duration-300 h-full">
                <div
                  className={`w-14 h-14 rounded-xl bg-gradient-to-br ${item.gradient} flex items-center justify-center mb-6 shadow-xs`}
                >
                  <item.icon className="w-7 h-7 text-white" aria-hidden="true" />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3">{item.title}</h3>
                <p className="text-gray-500 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AudienceSection;
